import { FC } from 'react';
import { capitalize, Chip } from '@mui/material';

interface CampaignChangeRequestStatusProps {
    value: string;
}

const CampaignChangeRequestStatus: FC<CampaignChangeRequestStatusProps> = ({ value }) => {
    let color: 'success' | 'warning' | 'error' | 'default';

    switch (value) {
        case 'Complete':
            color = 'success';
            break;

        case 'Pending':
            color = 'warning';
            break;

        case 'Declined':
            color = 'error';
            break;

        default:
            color = 'default';
            break;
    }
    return (
        <Chip
            size="small"
            label={capitalize(value.toLowerCase())}
            variant="filled"
            sx={{
                fontWeight: (theme) => theme.typography.fontWeightMedium,
            }}
            color={color}
        />
    );
};

export type { CampaignChangeRequestStatusProps };
export default CampaignChangeRequestStatus;
